import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-medium text-secondary-600 uppercase tracking-wider mb-3">
            Shop By Category
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-tight mb-2">
            All Spreadsheet Categories
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            One Click Away
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex items-center gap-4 p-4 md:p-5 bg-background-100 hover:bg-primary-50 border border-background-200 hover:border-primary-200 rounded-xl transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-background-50 group-hover:bg-primary-100 transition-colors duration-200 flex-shrink-0">
                <i className={`${cat.icon} text-lg text-foreground-700 group-hover:text-primary-600 transition-colors duration-200`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap truncate">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 group-hover:text-foreground-600 transition-colors duration-200 truncate">
                  {cat.description}
                </p>
              </div>
              <div className="ml-auto flex-shrink-0">
                <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 group-hover:translate-x-0.5 transition-all duration-200 text-lg"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}